import React from 'react';
import ModalContainer from 'components/molecules/ModalContainer';

// components
import IMAdjustmentForm from 'components/organisms/IMAdjustmentForm';
interface Props {
  open: boolean;
  onClose(): void;
  productId: number;
  getAllProducts(): void;
  parentId: number;
}

export default function IMAdjustmentModal({ open, onClose, productId, getAllProducts, parentId }: Props) {
  return (
    <ModalContainer open={open} title="Ajuste de inventario" onClose={onClose}>
      <IMAdjustmentForm
        productId={productId}
        parentId={parentId}
        getAllProducts={getAllProducts}
        handleCloseModal={onClose}
      />
    </ModalContainer>
  );
}
